// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

// Tooltip messages shown when selecting specific add-on deliverables
// Key is deliverableId, value is the tooltip message displayed in a confirmation dialog
const deliverableTooltips: Record<number, string> = {
  143: 'Symbols and text will be delivered as polylines.', // Pavemark Polyline
  144: 'Symbols will be delivered as polylines. All text will be delivered as MTEXT.', // AI-Generated Pavement Markings (MTEXT)
};

export default deliverableTooltips;
